import React, { useEffect, useState, useContext } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import axios from "axios";
import { serverInfo } from "../../../App";
import swal from "sweetalert";
import tik from "../../../assets/images/Rounds/sign.png";

const TableJuryPaginateReuse = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const [marks, setMarks] = useState({});
  const [markVideoId, setMarkVideoId] = useState("");
  const [loading, setLoading] = useState(false);
  const { data, tableHead, getRoundAndFilterableVideos } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const approvalHandler = (video) => {
    setLoading(true)
    const fData = new FormData();
    const mark = marks[video.id] || "";
    if (video.id === markVideoId && mark !== "") {
      fData.append("mark", mark);
    } else {
      var max_mark = Math.max(video.group_b_jury_mark, video.group_c_jury_mark);
      fData.append("mark", max_mark);
    }
    fData.append("video_id", video?.id);
    axios
      .post(`/api/jury/audition/mark-assessment-as-main-group`, fData)
      .then((res) => {
        if (res.data.status === 200) {
          setLoading(false)
          setMarks((prevMarks) => ({ ...prevMarks, [video.id]: "" })); // Reset the specific mark after success
          swal("Success", res.data.message, "success");
          getRoundAndFilterableVideos();
        }
      });
  };

  const markChangeHandler = (e, video) => {
    const value = e.target.value;
    setMarks((prevMarks) => ({ ...prevMarks, [video.id]: value }));
    setMarkVideoId(video?.id);
  };

  return (
    <>
      <div className="py-3">
        <div className="row mx-1" style={{ overflowX: "auto" }}>
          <Table className="table w-100" striped bordered hover variant="dark">
            <thead>
              <tr>
                {tableHead &&
                  tableHead.map((heading) => (
                    <th className="bg-warning text-center" key={heading}>
                      {heading}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {currentItems &&
                currentItems.map((user, index) => (
                  <tr key={index}>
                    <td className="text-center">{`${index + 1}`}</td>
                    <td style={{ width: "200px" }}>
                      <ReactPlayer
                        controls
                        url={videoCdnUrl + user.video}
                        width="200px"
                        height="100px"
                      />
                    </td>
                    <td className="text-center">{user.group_b_jury_mark}</td>
                    <td className="text-center">{user.group_c_jury_mark}</td>
                    <td className="text-center">
                      {user.group_a_jury_mark ? (
                        <>{user.group_a_jury_mark}</>
                      ) : (
                        <div className="d-flex" style={{ width: "210px" }}>
                          <input
                            type="number"
                            className="form-control reply-control"
                            placeholder="Enter Mark"
                            value={marks[user.id] || ""}
                            onChange={(e) => markChangeHandler(e, user)}
                          />

                          
                          <img
                            src={tik}
                            alt=""
                            width="55px"
                            height="50px"
                            type="button"
                            className="btn"
                            onClick={() => approvalHandler(user)}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div id="react-paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default TableJuryPaginateReuse;
